import { render, staticRenderFns } from "./ProductDialog.vue?vue&type=template&id=dead2fea&scoped=true&"
import script from "./ProductDialog.vue?vue&type=script&lang=js&"
export * from "./ProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductDialog.vue?vue&type=style&index=0&id=dead2fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dead2fea",
  null
  
)

export default component.exports